var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gc-status-chip"},[_c('label',{class:{
      active: _vm.status == 'Active',

      inactive: _vm.status == 'Inactive',
    }},[_vm._v(_vm._s(_vm.status))])])}
var staticRenderFns = []

export { render, staticRenderFns }